export const TextEffectsMatrixViewerType = 'wixui.TextEffectsMatrix' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsMatrix-container',
    text: 'TextEffectsMatrix-text',
  },
} as const;
